import { computed, ref } from 'vue'

// State
const filters = ref({
  isOnline: {
    inputType: 'tristate',
    text: 'Status',
    label: 'Online',
    tooltipYes: 'Online',
    tooltipNo: 'Offline',
    tooltipNeutral: 'All Users',
  },
  tags: {
    inputType: 'select',
    text: 'Tag',
    selectedOptionLabel: 'name',
    optionLabel: 'description',
    multiple: true,
    label: 'Tags',
    reduce: 'name',
    header: 'Select Tag(s)',
    variant: 'primary',
    data: [],
  },
  activities: {
    inputType: 'select',
    text: 'App',
    label: 'Apps Used',
    taggable: true,
    multiple: true,
    variant: 'info',
    header: 'Type app name',
    data: [],
  },
  assignees: {
    inputType: 'assignees-selector',
    text: 'Assignees',
    label: 'Assignees',
    variant: 'primary',
    multiple: true,
    reduce: 'uuid',
    header: 'Type assignee name',
    optionLabel: 'name',
    selectedOptionLabel: 'name',
    data: [],
  },
  labels: {
    inputType: 'select',
    text: 'Label',
    label: 'Labels',
    variant: 'info',
    multiple: true,
    reduce: 'uuid',
    header: 'Type label name',
    optionLabel: 'name',
    selectedOptionLabel: 'name',
    data: [],
  },
  taskPriority: {
    inputType: 'select',
    text: 'Priority',
    reduce: 'value',
    label: 'Priority',
    optionIcon: 'CircleIcon',
    header: 'Type or Select Priority',
    data: [
      {
        value: 'LOW', text: 'Low', description: 'Can be deferred', color: 'secondary',
      },
      {
        value: 'MEDIUM', text: 'Medium', description: 'Normal workflow', color: 'success',
      },
      {
        value: 'HIGH', text: 'High', description: 'Should be prioritized', color: 'warning',
      },
      {
        value: 'URGENT', text: 'Urgent', description: 'Needs immediate attention', color: 'danger',
      },
    ],
    optionLabel: 'text',
    selectedOptionLabel: 'text',
  },
})

const activeFilters = ref({})
const selectedFilters = ref({})

// Getters
const getFilters = computed(() => filters.value)
const getActiveFilters = computed(() => activeFilters.value)
const getSelectedFilters = computed(() => selectedFilters.value)
const totalActiveFilters = computed(() => Object.values(activeFilters.value).reduce((total, filterList) => (total + (Array.isArray(filterList) ? filterList.length : filterList !== null && filterList !== undefined)), 0))

// Actions
const setFilters = (type, value) => {
  filters.value[type].data = value
}

const setActiveFilters = value => {
  activeFilters.value = { ...value }
}

const removeActiveFilter = (filter, type) => {
  if (Array.isArray(activeFilters.value[type])) {
    activeFilters.value[type] = activeFilters.value[type]
      .filter(f => (filters.value[type].reduce ? f[filters.value[type].reduce] : f) !== filter)
  } else activeFilters.value[type] = null

  selectedFilters.value = Object.entries(activeFilters.value).reduce((acc, [key, activeFilter]) => {
    acc[key] = Array.isArray(activeFilter)
      ? activeFilter?.map(f => (filters.value[key].reduce ? f[filters.value[key].reduce] : f))
      : activeFilter
    return acc
  }, {})
}

const clearActiveFilters = () => {
  activeFilters.value = {
    ...Object.entries(filters.value).map(([key, filter]) => ({
      [key]: filter.multiple ? [] : null,
    })).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
  }
  selectedFilters.value = activeFilters.value
}

export default function useFilters() {
  return {
    getFilters,
    getActiveFilters,
    getSelectedFilters,
    totalActiveFilters,

    setFilters,
    setActiveFilters,
    removeActiveFilter,
    clearActiveFilters,
  }
}
